var getFrontendApiEndPoint = function () {
    var _a;
    return (_a = process.env.REACT_APP_API_END_POINT) !== null && _a !== void 0 ? _a : '';
};
export var API_END_POINT = getFrontendApiEndPoint();
export var DEFAULT_NPS_TEXT = '当店をお知り合いなどにおすすめしたいと思いますか？';
